const { aliasInputFields } = require('./outlets-const')

const SUPPORTED_IMAGE_TYPES = [
  "image/bmp",
  "image/gif",
  "image/png",
  "image/jpeg",
  "image/jpg"
];

const BULK_UPDATE = {
  ACTION_TARGET: {
    FILTERED: 'filtered',
    SELECTED: 'selected'
  }
};

// TODO: set default permissions for each role: Coder, Senior Coder, Team Leader, Project Manager, and Report Writer.
const USER_PERMISSIONS = {
  ROLES: {
    DEFAULT: {
      view_coder_home: []
    }
  },
  ARTICLE_SCREEN_DATA: {
    ID: "article_id",
    HEADLINE: "headline",
    CREATED_AT: "date_created",
    PUBLISHED_AT: "date_published",
    OUTLET: "outlet",
    LANGUAGE: "language",
    ASSIGNED_TO: "assigned_to",
    ASSIGNED_BY: "assigned_by",
    STATUS: "status",
    DUE_DATE: "due_date",
    FAV_SCORE: "fav_score"
  },
  CODER_HOME_SCREEN: {
    RATING: "rating",
    LOCATION: "location",
    QC_SCORE: "qc_score",
    PAYMENT_RATE: "payment_rate"
  },
  EDIT_PROJECT_SETUP: "edit_project_setup",
  VIEW_CODERS_LIST: "view_coders_list",
  ASSIGN_ARTICLES: {
    YES: "yes",
    NO: "no",
    SELF: "self"
  },
  VIEW_GROUPS_SCREENS: "view_articles_group_notes",
  VIEW_CODING_UI: "view_coding_ui"
};

const QUERIES = {
  TIME_PERIOD_TYPE: {
    CURRENT: 'current',
    TREND: 'trend',
    FIXED: 'fixed'
  },
  COMPARE_TYPE: {
    RELATIVE: 'relative',
    FIXED: 'fixed'
  },
  FILTER_TYPE: {
    TAG: 'tag',
    CATEGORY: 'category',
    GROUP: 'group',
    BREAKDOWN: 'breakdown'
  },
  ALLOW_DRAG: {
    FILTERS: "filters",
    EXTERNAL_FILTERS: "external_filters",
    AXIS: "axis",
  },
  SHORTCUT_COMMANDS: {
    SAVE: "save",
    RUN: "run",
    BACK_TO_QUERY_LIST: 'back_to_query_list'
  },
  STANDARD_BREAKDOWN: {
    TIME: {
      QUARTER: 'quarter',
      FINANCIAL_YEAR: 'financial_year'
    }
  },
  SAVE_ACTIONS: {
    SAVE: "save",
    SAVE_AS: "saveAs",
    EDIT: "edit",
    CREATE_NEW: 'createNew'
  },
  AVE: {
    LABEL: 'AVE'
  },
  ERRORS: {
    INVALID_MV_REQUIREMENTS: "invalid_mv_requirements",
    MV_NOT_FOUND: "mv_not_found"
  },
  OUTPUTS: {
    ARTICLE_COUNT: 1,
    DISTINCT_COUNT: 8,
    PERCENTAGE: 10,
    MENTIONS: 22,
    RANK: 23,
    TREND_PERCENTAGE: 24
  },
  ALLOW_EXTERNAL_FILTERS_SEARCHABLE: [3,4,7,8,11],
  ALLOW_EXTERNAL_FILTERS_SKIP_LIMIT: [7,8,11]
};

const ARTICLE_STATUS = {
  IRRELEVANT: 5,
  CODED: 6,
  PUBLISHED_NOT_QC: 7,
  PUBLISHED_QC: 8,
  ERROR: 10,
  QUEUED: 11
}

const FIELD_TYPE = {
  TEXTAREA: "textarea",
  INPUT: "input",
  SELECT: "select",
  CALENDAR: "calendar",
  COLOR: "color",
  CHECKBOX: "checkbox",
  CUSTOM: "custom",
  BUTTON: "button",
  TOGGLE: "toggle",
  FILES: "files",
  FILES_UPLOAD: "files_upload",
  DAYOFWEEK: "dayOfWeek",
  NUMBER: "number",
  QUERYEDITOR: "queryEditor",
  BOOLEANSEARCH: "booleanSearch",
  DATE_RANGE: "date_range"
};

const VALIDATIONS = {
  REQUIRED: 'required',
  NUMBER: 'number',
  CLEAN_STRING: 'clean_string',
  NO_LEADING_OR_TRAILING_SPACES: 'no_leading_or_trailing_spaces',
  EMAIL_FORMAT: 'email_format',
  URL_FORMAT: 'url_format',
  SEARCH_STRING: 'search_string',
  BRACKETS_MATCH: 'brackets_match',
  UNIQUE: 'unique', // requires :fieldsAdditions="{fieldName: { unique: { values: values}}}"
  REQUIRE_ONE_OF: 'require_one_of',
  QUERYEDITOR_SYNTAX: 'queryeditor_syntax',
  QUERYEDITOR_ASIAN_SYNTAX: 'queryeditor_asian_syntax',
  BOOLEAN_SEARCH_SYNTAX: 'booleansearch_syntax',
  STRING_MAX_LENGTH: 'string_max_length',
  CUSTOM: 'custom'
};

const MEDIA_SUBTYPES = {
  NEWSPAPER: 'newspaper',
  MAGAZINE: 'magazine',
  WEBSITE: 'website',
  BLOG: 'blog',
  NEWS: 'news',
  TV: 'tv',
  RADIO: 'radio',
  PODCAST: 'podcast',
  SOCIAL_NETWORKS: 'social-networks',
}

const MEDIA_TYPES = {
  PRINT: [MEDIA_SUBTYPES.NEWSPAPER, MEDIA_SUBTYPES.MAGAZINE],
  ONLINE: [MEDIA_SUBTYPES.WEBSITE, MEDIA_SUBTYPES.NEWS],
  BROADCAST: [MEDIA_SUBTYPES.TV, MEDIA_SUBTYPES.RADIO, MEDIA_SUBTYPES.PODCAST],
  SOCIAL: [MEDIA_SUBTYPES.SOCIAL_NETWORKS]
}

// custom validations schema:
// inputFieldName: { nameOfValidation: {validation, message or translate_message }}}
const CUSTOM_VALIDATIONS = {
  add_edit_tag_form: {
    name: {
      duplicateName: {
        validation: 'duplicateNameValidation', // name of the validation fn
        translate_message: 'tags_menu.existing_tag', // t18n message (*)
        message: '' // message string (*)
      }
    }
  },
  boolean_detail: {
    name: {
      nameValidation: {
        validation: 'boolNameValidation', // name of the validation fn
        translate_message: 'form.validation_messages.boolean_name', // t18n message (*)
        message: '' // message string (*)
      }
    },
    must_include_terms: {
      maxkeywordsValidation: {
        validation: 'searchTermsValidation',
        translate_message: 'booleanSearch.search_terms_count_limit',
        message: ''
      }
    }
  }
}

const TITLES = [
  {
    value: 'Dr',
    label: 'Dr'
  },{
    value: 'Mr',
    label: 'Mr'
  }, {
    value: 'Mrs',
    label: 'Mrs'
  }, {
    value: 'Ms',
    label: 'Ms'
  }
];

const INPUT_FIELDS = {
  name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'categories.labels.name.title',
    id: 'name',
    name: 'name',
    validate: [VALIDATIONS.REQUIRED]
  },
  category_type_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'categories.labels.category_type.title',
    id: 'category-type',
    name: 'category_type_id',
    validate: [VALIDATIONS.REQUIRED],
    preselectFirst: true,
    allowEmpty: true
  },
  cat_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'sources.category.title',
    id: 'category',
    name: 'cat_id',
    options: [],
    searchable: true,
    optionsLimit: 100,
    dropdownDirection: 'top',
    translatePlaceholder: 'sources.category.select',
    hideSelected: false,
    trackBy: 'value',
    validate: [VALIDATIONS.REQUIRED],
    allowEmpty: true
  },
  coder_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'coder.labels.name.title',
    translatePlaceholder: 'coder.labels.name.select',
    id: 'coder_id',
    name: 'coder_id',
    validate: [VALIDATIONS.REQUIRED],
    preselectFirst: true,
    allowEmpty: true
  },
  //SOURCE INPUT FIELDS
  first_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.first_name.title',
    id: 'first-name',
    name: 'first_name',
    validate: [VALIDATIONS.REQUIRED],
  },
  middle_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.middle_name.title',
    id: 'middle-name',
    name: 'middle_name'
  },
  last_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.last_name.title',
    id: 'last-name',
    name: 'last_name',
    validate: [VALIDATIONS.REQUIRED]
  },
  title: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.title.title',
    id: 'title',
    name: 'title',
    options: TITLES,
    searchable: false,
    validate: [],
    dropdownDirection: 'bottom',
  },
  job_title: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.job_title.title',
    id: 'job_title',
    name: 'job_title'
  },
  display_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.display_name.title',
    id: 'display_name',
    name: 'display_name'
  },
  affiliation_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'tag.labels.affiliation_id.title',
    id: 'affiliation_id',
    name: 'affiliation_id',
    trackBy: 'value',
    searchable: true,
    optionsLimit: 100,
    taggable: true,
    tagPlaceholder: "Press enter to create affiliation",
    validate: [VALIDATIONS.REQUIRED],
    options: [],
    allowEmpty: true
  },
  organization: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'organizations',
    id: 'organization',
    name: 'organization',
    options: [],
    searchable: true,
    dropdownDirection: 'bottom',
    hideSelected: false,
    trackBy: 'value',
    validate: [VALIDATIONS.REQUIRED],
    preselectFirst: true,
    allowEmpty: true
  },
  //BREAKDOWN INPUT FIELDS
  search_string: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'breakdown.text.search_string',
    id: 'text-search-string',
    name: 'search_string',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.SEARCH_STRING, VALIDATIONS.BRACKETS_MATCH],
    style: 'flex-basis: 100%'
  },
  //OUTLET INPUT FIELDS
  url: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.url',
    id: this.listType + '-url',
    name: 'url',
    style: 'flex-basis: 100%',
    validate: [VALIDATIONS.URL_FORMAT]
  },
  media_type: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.media_type.title',
    id: this.listType + '-media-type',
    name: 'media_type',
    options: [],
    searchable: true,
    optionsLimit: 100,
    dropdownDirection: 'bottom',
    translatePlaceholder: 'outlets.media_type.select',
    hideSelected: false,
    style: 'flex-basis: 100%',
    customLabel: this.displayLabel,
    trackBy: 'value',
    validate: [VALIDATIONS.REQUIRED],
    allowEmpty: true
  },
  country: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.country.title',
    translatePlaceholder: 'outlets.country.select',
    id: this.listType + '-country',
    name: 'country',
    options: [],
    searchable: true,
    optionsLimit: 100,
    dropdownDirection: 'bottom',
    hideSelected: false,
    style: 'flex-grow: 1',
    customClass: 'mr10',
    customLabel: this.displayLabel,
    trackBy: 'value',
    allowEmpty: true
  },
  outlets: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'articles.labels.outlet.title',
    id: this.listType + '-outlet',
    name: 'outlets',
    options: [],
    searchable: true,
    searchableProps: ['name', 'id'],
    optionsLimit: 100,
    dropdownDirection: 'bottom',
    hideSelected: false,
    style: 'flex-grow: 1',
    customClass: 'mr10',
    customLabel: this.displayLabel,
    trackBy: 'id'
  },
  outlets_multiple: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'articles.labels.outlet.title',
    id: this.listType + '-outlet',
    name: 'outlets',
    options: [],
    multiple: true,
    searchable: true,
    optionLabel: 'name',
    optionValue: 'id',
    searchableProps: ['id', 'name'],
    optionsLimit: 100,
    dropdownDirection: 'bottom',
    hideSelected: false,
    style: 'flex-grow: 1',
    customClass: 'mr10',
    customLabel: this.displayLabel,
    trackBy: 'id'
  },
  social_media_platforms: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.social_media_platforms.title',
    translatePlaceholder: 'autoAssign.labels.social_media_platforms.placeholder',
    id: 'social_media_platforms',
    name: 'social_media_platforms',
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  account_type: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.account_type.title',
    translatePlaceholder: 'autoAssign.labels.account_type.placeholder',
    id: 'account_type',
    name: 'account_type',
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  post_types: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.post_types.title',
    translatePlaceholder: 'autoAssign.labels.post_types.placeholder',
    id: 'post_types',
    name: 'post_types',
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  exclude_post_types: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.exclude_post_types.title',
    translatePlaceholder: 'autoAssign.labels.exclude_post_types.placeholder',
    id: 'exclude_post_types',
    name: 'exclude_post_types',
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  minimum_followers: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'autoAssign.labels.minimum_followers.title',
    translatePlaceholder: 'autoAssign.labels.minimum_followers.placeholder',
    id: 'minimum_followers',
    name: 'minimum_followers',
    inputType: 'number',
    min: 0
  },
  include_handle: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.include_handle.title',
    translatePlaceholder: 'autoAssign.labels.include_handle.placeholder',
    id: 'include_handle',
    name: 'include_handle',
    multiple: true,
    searchable: true,
    hideSelected: true,
    taggable: true,
    translateTagPlaceholder: 'autoAssign.labels.include_handle.add_include_handle',
    translateNoOptions: 'autoAssign.labels.include_handle.add_include_handle',
    options: [],
    style: 'flex-basis: 50%;',
    showNoResults: false,
    allowEmpty: true,
    dropdownDirection: 'bottom'
  },
  exclude_handle: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.exclude_handle.title',
    translatePlaceholder: 'autoAssign.labels.exclude_handle.placeholder',
    id: 'exclude_handle',
    name: 'exclude_handle',
    multiple: true,
    searchable: true,
    hideSelected: true,
    taggable: true,
    translateTagPlaceholder: 'autoAssign.labels.exclude_handle.add_exclude_handle',
    translateNoOptions: 'autoAssign.labels.exclude_handle.add_exclude_handle',
    options: [],
    style: 'flex-basis: 50%;',
    showNoResults: false,
    allowEmpty: true,
    dropdownDirection: 'bottom'
  },
  user_locations: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.user_locations.title',
    translatePlaceholder: 'autoAssign.labels.user_locations.placeholder',
    id: 'user_locations',
    name: 'user_locations',
    multiple: true,
    options: [],
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  region: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.region.title',
    id: this.listType + '-region',
    name: 'region',
    options: [],
    searchable: true,
    optionsLimit: 100,
    dropdownDirection: 'bottom',
    translatePlaceholder: 'outlets.region.select',
    hideSelected: false,
    style: 'flex-grow: 1',
    customLabel: this.displayLabel,
    trackBy: 'value',
    allowEmpty: true
  },
  //TAG INPUT FIELDS
  weight: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'tag.labels.weighting.title',
    id: 'add-category-weighting',
    name: 'weight',
    inputType: 'number',
    decimalPoints: 2,
    validate: [VALIDATIONS.REQUIRED]
  },
  customColor: {
    type: FIELD_TYPE.COLOR,
    translate_label: 'tag.labels.color.title',
    id: 'add-category-color',
    name: 'customColor'
  },
  allowRelationship: {
    type: FIELD_TYPE.CHECKBOX,
    translate_label: 'tag.labels.allow_relationship.title',
    id: 'add-category-allow-relationship',
    name: 'allowRelationship'
  },
  //AUTO ASSIGN INPUT FIELDS
  tiers: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.tiers.title',
    translatePlaceholder: 'outlets.tiers.multi_select',
    id: 'tiers',
    name: 'tiers',
    multiple: true,
    options: [
      {label: 'Tier 1', value: 1},
      {label: 'Tier 2', value: 2},
      {label: 'Tier 3', value: 3}
    ],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  relevancy: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'relevancy.form.auto_assign.title',
    translatePlaceholder: 'relevancy.form.auto_assign.multi_select',
    id: 'relevancy',
    name: 'relevancy',
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  ai_models: {
    type: FIELD_TYPE.SELECT,
    id: 'ai_models',
    name: 'ai_models',
    translate_label: 'articles.ai_models',
    translate_label_tooltip: 'articles.ai_model_tooltip',
    showInfoIcon: true,
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  outlet_groups: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.outlet_groups.title',
    translatePlaceholder: 'autoAssign.labels.outlet_groups.placeholder',
    id: 'outlet_groups',
    name: 'outlet_groups',
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  filter_label:{
    type: FIELD_TYPE.LABEL,
    translate_label: 'autoAssign.labels.filter',
  },
  action_label: {
    type: FIELD_TYPE.LABEL,
    translate_label: 'autoAssign.labels.action',
  },
  tags: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'tag.labels.tags.title',
    translatePlaceholder: 'tag.labels.tags.multi_select',
    id: 'tags',
    name: 'tags',
    searchable: true,
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  exclude_tags: {
    type: FIELD_TYPE.SELECT,
    translatePlaceholder: 'tag.labels.tags.multi_select',
    id: 'exclude_tags',
    name: 'exclude_tags',
    searchable: true,
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  private_tags: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'tag.labels.private_tags.title',
    translatePlaceholder: 'tag.labels.private_tags.multi_select',
    id: 'private_tags',
    name: 'private_tags',
    searchable: true,
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  exclude_private_tags: {
    type: FIELD_TYPE.SELECT,
    translatePlaceholder: 'tag.labels.private_tags.multi_select',
    id: 'exclude_private_tags',
    name: 'exclude_private_tags',
    searchable: true,
    multiple: true,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  state_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'articles.status',
    translatePlaceholder: 'articles.status',
    id: 'state_id',
    name: 'state_id',
    searchable: true,
    multiple: false,
    options: [],
    hideSelected: false,
    style: 'flex-basis: 50%;'
  },
  language: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.languages.title',
    translatePlaceholder: 'autoAssign.labels.languages.placeholder',
    id: 'language',
    name: 'language',
    searchable: true,
    options: [],
    hideSelected: false,
    multiple: false,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  headline: {
    type: FIELD_TYPE.INPUT,
    id: "article-headline",
    name: "headline",
    translate_label: "articles.labels.headline.title",
    style: "flex-basis: 100%",
    validate: [VALIDATIONS.REQUIRED]
  },
  headline_language: {
    type: FIELD_TYPE.SELECT,
    id: "article-headline-language",
    name: "headline_language",
    translate_label: "articles.labels.headline_language.title",
    searchable: true,
    multiple: false,
    allowEmpty: true,
    style: "flex-basis: 50%",
    validate: [VALIDATIONS.REQUIRED],
    options: [],
  },
  headline_prompt: {
    type: FIELD_TYPE.TOGGLE,
    id: "headline_prompt",
    name: "headline_prompt",
    translate_label: "articles.labels.headline_prompt.title",
    style: "flex-basis: 50%",
  },
    headline_prompt_text: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'articles.labels.headline_prompt_text.title',
    name: 'headline_prompt_text',
    id: 'headline_prompt_text',
    validate: [VALIDATIONS.REQUIRED],
    style: "width: 100%;"
  },
  context: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'carma_ai.form.labels.noor_context',
    name: 'context',
    id: 'context',
    style: "width: 100%;",
    validate: [VALIDATIONS.STRING_MAX_LENGTH]
  },
   headline_ai_model_id: {
    type: FIELD_TYPE.SELECT,
    id: "headline_ai_model_id",
    name: "headline_ai_model_id",
    translate_label: "ai_coding.fields.headline_ai_model",
    multiple: false,
    allowEmpty: true,
    style: "flex-basis: 50%",
    validate: [VALIDATIONS.REQUIRED],
    options: []
  },
    headline_provider: {
    type: FIELD_TYPE.SELECT,
    id: "headline_provider",
    name: "headline_provider",
    translate_label: "ai_coding.fields.headline_provider",
    searchable: true,
    multiple: false,
    allowEmpty: true,
    style: "flex-basis: 50%",
    validate: [VALIDATIONS.REQUIRED],
    options: [],
  },
  provider: {
    type: FIELD_TYPE.SELECT,
    id: "provider",
    name: "provider",
    translate_label: "ai_coding.fields.provider",
    searchable: true,
    multiple: false,
    allowEmpty: true,
    style: "flex-basis: 50%",
    validate: [VALIDATIONS.REQUIRED],
    options: [],
  },
  ai_model_id: {
    type: FIELD_TYPE.SELECT,
    id: "ai_model_id",
    name: "ai_model_id",
    translate_label: "ai_coding.fields.model",
    searchable: true,
    multiple: false,
    allowEmpty: true,
    style: "flex-basis: 50%",
    validate: [VALIDATIONS.REQUIRED],
    options: []
  },
  date_published: {
    type: FIELD_TYPE.CALENDAR,
    id: "article-date-published",
    name: "date_published",
    translate_label: "articles.labels.date_publish.title",
    inputClass: 'input-ui',
    editable: true,
    clearable: false,
    format: 'D MM YYYY',
    validate: [VALIDATIONS.REQUIRED],
    style: "flex-basis: 33%;"
  },
  priority: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'autoAssign.labels.priority.title',
    id: 'priority',
    name: 'priority',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED],
    options: [
      {label: '1 (Highest Priority)', value: 1}, {label: '2', value: 2}, {label: '3', value: 3}, {label: '4', value: 4},
      {label: '5', value: 5}, {label: '6', value: 6}, {label: '7', value: 7},
      {label: '8', value: 8}, {label: '9', value: 9}, {label: '10 (Lowest Priority)', value: 10}
    ],
    preselectFirst: true,
    style: 'flex-basis: 50%;',
    allowEmpty: true
  },
  label: {
    type: FIELD_TYPE.INPUT,
    id: 'new-folder-name',
    translate_label: 'folders.name',
    translate_placeholder: 'save.folder_name',
    name: 'label',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.UNIQUE],
    style: 'flex-basis: 100%'
  },
  frontPage: {
    type: FIELD_TYPE.TOGGLE,
    id: "article-front-page",
    name: "front_page",
    translate_label: "articles.labels.front_page.title",
    labelPosition: 'right',
    style: "flex-basis: 50%"
  },
  press_release: {
    type: FIELD_TYPE.TOGGLE,
    id: "article-press-release",
    name: "press_release",
    translate_label: "articles.labels.press_release.title",
    labelPosition: 'right',
    style: "flex-basis: 50%"
  },
  authors_id: {
    type: FIELD_TYPE.SELECT,
    id: "article-authors",
    name: "author_id",
    translate_label: "articles.labels.authors.title",
    searchable: true,
    multiple: true,
    allowEmpty: true,
    style: "flex-basis: 50%",
    options: []
  },
  content: {
    type: FIELD_TYPE.TEXTAREA,
    id: "article-content",
    name: "content",
    translate_label: "articles.labels.content.title",
    style: "flex-basis: 100%",
    validate: [VALIDATIONS.REQUIRED]
  },
  files: {
    type: FIELD_TYPE.FILES,
    id: "files_upload",
    name: 'files',
    get_files_url: null,
    remove_url: null,
    upload_url: null,
    download_url: null,
    max_number_files: 10,
    max_file_size: "10mb",
    prevent_duplicates: true,
    programmatic_upload: false
  },
  files_upload: {
    type: FIELD_TYPE.FILES_UPLOAD,
    id: 'files_upload',
    name: 'files_upload',
    max: 10,
  },
  files_upload_excel: {
    type: FIELD_TYPE.FILES_UPLOAD,
    id: 'files_upload_excel',
    name: 'files_upload_excel',
    max: 1,
    accept: `
      .csv,
      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
      application/vnd.ms-excel
    `
  },
  file_outlets_import: {
    type: FIELD_TYPE.FILES_UPLOAD,
    id: 'file_outlets_import',
    name: 'file_outlets_import',
    max: 1,
    accept: `
      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
      application/vnd.ms-excel
    `
  },
  file_pptx: {
    type: FIELD_TYPE.FILES_UPLOAD,
    id: 'file_pptx',
    name: 'file_pptx',
    max: 1, // Allow one Excel and one PowerPoint file
    accept: `                              
      .pptx,.pptm
    `
  },
  file_xlsx: {
    type: FIELD_TYPE.FILES_UPLOAD,
    id: 'file_xlsx',
    name: 'file_xlsx',
    max: 1, // Allow one Excel and one PowerPoint file
    accept: `                              
      .xlsx                                                       
    `
  },    
  // Boolean Search
  boolName: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'booleanSearch.details.fields.name',
    translatePlaceholder: 'booleanSearch.fields.namePlaceholder',
    id: 'boolName',
    name: 'name',
    validate: [VALIDATIONS.REQUIRED],
    customClass: 'name',
    style: 'flex-basis: 50%;',
  },
  boolTagCategory:{
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.details.fields.tagCategory',
    translatePlaceholder: 'booleanSearch.details.fields.tagCategoryPlaceholder',
    id: 'boolTagCategory',
    name: 'tagCategory',
    searchable: false,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: false,
    preselectFirst: true,
    customClass: 'description',
    style: 'flex-basis: 50%;',
  },
  isPrivateTag: {
    type: FIELD_TYPE.TOGGLE,
    id: 'isPrivateTag',
    name: 'is_private',
    translate_label: 'booleanSearch.details.fields.isPrivateTag',
    labelPosition: 'left',
    style: 'flex-basis: 50%;',
  },
  boolSearchType: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.details.fields.searchType',
    translatePlaceholder: 'booleanSearch.details.fields.searchTypePlaceholder',
    id: 'boolSearchType',
    name: 'searchType',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: false,
    preselectFirst: true,
    customClass: 'description',
    style: 'flex-basis: 50%;',
  },
  boolDescription: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'booleanSearch.details.fields.description',
    id: 'description',
    name: 'description',
    customClass: 'description',
    style: 'grid-column: 1 / -1;'
  },
  boolUpload: {
    type: FIELD_TYPE.FILES_UPLOAD,
    id: 'file',
    name: 'file',
    max: 1,
    accept: `
      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
      application/vnd.ms-excel
    `
  },
  boolExportFormat: {
    type: FIELD_TYPE.SELECT,
    id: 'format',
    name: 'format',
    label: 'Format',
    options: [{ label: 'CSV', value: 'csv' }, { label: 'Excel', value: 'xlsx' }],
    allowEmpty: false
  },
  boolExportPreventGroupReplace: {
    type: FIELD_TYPE.TOGGLE,
    id: 'do_not_replace_group',
    name: 'do_not_replace_group',
    label: 'Do Not Replace Group'
  },

  locations: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.locations',
    translatePlaceholder: 'booleanSearch.filters.fields.locations',
    id: 'locations',
    name: 'locations',
    optionLabel: 'name',
    optionValue: 'alpha_2_code',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'locations',
  },

  socialInfluencer: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.socialInfluencer',
    translatePlaceholder: 'booleanSearch.filters.fields.socialInfluencer',
    id: 'socialInfluencer',
    name: 'socialInfluencer',
    optionLabel: 'name',
    optionValue: 'value',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'socialInfluencer',
  },

  includeInfluencers: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeInfluencers',
    translatePlaceholder: 'booleanSearch.filters.fields.includeInfluencers',
    id: 'includeInfluencers',
    name: 'includeInfluencers',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeInfluencers',
  },

  includeMediaSubtypes: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeMediaSubtypes',
    translatePlaceholder: 'booleanSearch.filters.fields.includeMediaSubtypes',
    id: 'includeMediaSubtypes',
    name: 'includeMediaSubtypes',
    searchable: false,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeMediaSubtypes',
  },

  boolOutletCategories: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.outletCategories',
    translatePlaceholder: 'booleanSearch.filters.fields.outletCategories',
    id: 'outletCategories',
    name: 'outletCategories',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'outletCategories',
  },
  twitterPeriod: {
    id: 'twitterPeriod',
    format: 'YYYY-MM-DD',
    name: 'twitterPeriod',
    range: true,
    type: FIELD_TYPE.CALENDAR,
    clearable: false,
    maxDate: new Date(),
  },
  rs_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'name',
    id: 'rs_name',
    name: 'rs_name',
    validate: [VALIDATIONS.REQUIRED]
    // style: 'width: 32%',
  },
  rs_type: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'type',
    id: 'rs_type',
    allowEmpty: false,
    name: 'rs_type',
    validate: [VALIDATIONS.REQUIRED]
    // style: 'width: 32%',
  },
  twitterFilter: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.twitterFilters',
    translatePlaceholder: 'booleanSearch.filters.fields.twitterFilters',
    id: 'twitterFilters',
    name: 'twitterFilters',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'twitterFilters',
  },
  biolocations: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.biolocations',
    translatePlaceholder: 'booleanSearch.filters.fields.biolocations',
    id: 'biolocations',
    name: 'biolocations',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'biolocations',
    taggable: true,
    // translate_label_tooltip: 'booleanSearch.filters.fields.biolocations',
    translateTagPlaceholder: 'booleanSearch.filters.create'
  },
  deepSearchLocation: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'booleanSearch.filters.fields.deepSearchLocation',
    translatePlaceholder: 'booleanSearch.filters.fields.deepSearchLocation',
    id: 'deepSearchLocation',
    name: 'deepSearchLocation',
    labelPosition: 'right',
    style: 'grid-column: span 2',
    // translate_label_tooltip: 'booleanSearch.filters.fields.deepSearchLocation'
  },
  minFollowerBiolocation: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'booleanSearch.filters.fields.minFollowerBiolocation',
    id: 'min_follower_biolocation',
    name: 'min_follower_biolocation',
    inputType: 'number',
    validate: [VALIDATIONS.NUMBER],
    min: 1
  },
  twitterMinFollowers: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'booleanSearch.filters.fields.twitterMinFollowers',
    id: 'twitter_min_followers',
    name: 'twitter_min_followers',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER]
  },

  twitterSearches: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.twitterSearches',
    translatePlaceholder: 'booleanSearch.filters.fields.twitterSearches',
    id: 'twitterSearches',
    name: 'twitterSearches',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
  },

  includeUsers: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeUsers',
    translatePlaceholder: 'booleanSearch.filters.fields.includeUsers',
    id: 'includeUsers',
    name: 'includeUsers',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'booleanSearch.filters.create_user'
  },
  excludeUsers: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeUsers',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeUsers',
    id: 'excludeUsers',
    name: 'excludeUsers',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'booleanSearch.filters.create_user'
  },
  mustIncludeTerms: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.mustIncludeTerms',
    translatePlaceholder: 'booleanSearch.filters.fields.mustIncludeTerms',
    id: 'mustIncludeTerms',
    name: 'mustIncludeTerms',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'booleanSearch.filters.create_term'
  },
  shouldIncludeTerms: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.shouldIncludeTerms',
    translatePlaceholder: 'booleanSearch.filters.fields.shouldIncludeTerms',
    id: 'shouldIncludeTerms',
    name: 'shouldIncludeTerms',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'booleanSearch.filters.create_term'
  },
  mustExcludeTerms: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.mustExcludeTerms',
    translatePlaceholder: 'booleanSearch.filters.fields.mustExcludeTerms',
    id: 'mustExcludeTerms',
    name: 'mustExcludeTerms',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'booleanSearch.filters.create_term'
  },

  includeLocations: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeLocations',
    translatePlaceholder: 'booleanSearch.filters.fields.includeLocations',
    id: 'includeLocations',
    name: 'includeLocations',
    optionLabel: 'name',
    optionValue: 'alpha_2_code',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeLocations',
    // style: 'flex-basis: 50%;',
  },
  excludeLocations: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeLocations',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeLocations',
    id: 'excludeLocations',
    name: 'excludeLocations',
    optionLabel: 'name',
    optionValue: 'alpha_2_code',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeLocations',
    // style: 'flex-basis: 50%;',
  },
  includeStates: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeStates',
    translatePlaceholder: 'booleanSearch.filters.fields.includeStates',
    id: 'includeStates',
    name: 'includeStates',
    optionLabel: 'state',
    optionValue: 'state',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeStates',
    // style: 'flex-basis: 50%;',
  },
  excludeStates: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeStates',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeStates',
    id: 'excludeStates',
    name: 'excludeStates',
    optionLabel: 'state',
    optionValue: 'state',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeStates',
  },
  includeLanguages: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeLanguages',
    translatePlaceholder: 'booleanSearch.filters.fields.includeLanguages',
    id: 'includeLanguages',
    name: 'includeLanguages',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeLanguages',
    // style: 'flex-basis: 50%;',
  },
  excludeLanguages: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeLanguages',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeLanguages',
    id: 'excludeLanguages',
    name: 'excludeLanguages',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeLanguages',
    // style: 'flex-basis: 50%;',
  },
  includeOutlets: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeOutlets',
    translatePlaceholder: 'booleanSearch.filters.fields.includeOutlets',
    id: 'includeOutlets',
    name: 'includeOutlets',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeOutlets',
    // style: 'flex-basis: 50%;',
  },
  excludeOutlets: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeOutlets',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeOutlets',
    id: 'excludeOutlets',
    name: 'excludeOutlets',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeOutlets',
    // style: 'flex-basis: 50%;',
  },
  includeOutletGroups: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeOutletGroups',
    translatePlaceholder: 'booleanSearch.filters.fields.includeOutletGroups',
    id: 'includeOutletGroups',
    name: 'includeOutletGroups',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeOutletGroups',
    // style: 'flex-basis: 50%;',
  },
  excludeOutletGroups: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeOutletGroups',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeOutletGroups',
    id: 'excludeOutletGroups',
    name: 'excludeOutletGroups',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeOutletGroups',
    // style: 'flex-basis: 50%;',
  },
  includeCategories: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeCategories',
    translatePlaceholder: 'booleanSearch.filters.fields.includeCategories',
    id: 'includeCategories',
    name: 'includeCategories',
    searchable: false,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeCategories',
    // style: 'flex-basis: 50%;',
  },
  excludeCategories: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeCategories',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeCategories',
    id: 'excludeCategories',
    name: 'excludeCategories',
    searchable: false,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeCategories',
    // style: 'flex-basis: 50%;',
  },
  includeTags: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.includeTags',
    translatePlaceholder: 'booleanSearch.filters.fields.includeTags',
    id: 'includeTags',
    name: 'includeTags',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'includeTags',
    // style: 'flex-basis: 50%;',
  },
  excludeTags: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.excludeTags',
    translatePlaceholder: 'booleanSearch.filters.fields.excludeTags',
    id: 'excludeTags',
    name: 'excludeTags',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    customClass: 'excludeTags',
    // style: 'flex-basis: 50%;',
  },
  groups: {
    id: 'groups',
    name: 'groups',
    type: FIELD_TYPE.SELECT,
    translate_label: 'group.labels.title',
    options: [],
    preselectFirst: false,
    multiple: true,
    searchable: true
  },
  keywords: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.filters.fields.keywords',
    translatePlaceholder: 'booleanSearch.filters.fields.keywords',
    id: 'keywords',
    name: 'keywords',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'booleanSearch.filters.fields.keywordsAdd',
    customClass: 'keywords',
    showNoResults: false,
    translateNoOptions: 'booleanSearch.filters.fields.keywordsAdd',
    dropdownDirection: 'bottom'
  },
  'query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.query.title',
    translate_label_tooltip: 'booleanSearch.queries.fields.query.description',
    id: 'query',
    name: 'query',
    queryKey: 'query',
    validate: [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX],
  },
  'regex_query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.regex_query.title',
    translate_label_tooltip: 'booleanSearch.queries.fields.regex_query.description',
    id: 'regex_query',
    name: 'regex_query',
    queryKey: 'regex_query',
    validate: [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX],
  },
  'user_query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.user_query.title',
    translate_label_tooltip: 'booleanSearch.queries.fields.user_query.description',
    id: 'user_query',
    name: 'user_query',
    queryKey: 'user_query',
    validate: [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX],
  },
  // Should always be in sync with MT Asian server
  'media_track_query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.media_track_query.title',
    translate_label_tooltip: 'booleanSearch.queries.fields.media_track_query.description',
    id: 'media_track_query',
    name: 'media_track_query',
    queryKey: 'media_track_query',
    disabled: true,
  },
  'standard_query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.standard_query.title',
    translate_label_tooltip: 'booleanSearch.queries.fields.standard_query.description',
    id: 'standard_query',
    name: 'standard_query',
    queryKey: 'standard_query',
    validate: [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX],
  },
  'multi_provider_standard_query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.standard_query.multi_provider_title',
    translate_label_tooltip: 'booleanSearch.queries.fields.standard_query.description',
    id: 'standard_query',
    name: 'standard_query',
    queryKey: 'standard_query',
    validate: [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX],
  },
  'twitter_standard_query': {
    type: FIELD_TYPE.QUERYEDITOR,
    translate_label: 'booleanSearch.queries.fields.standard_query.after_filter_title',
    translate_label_tooltip: 'booleanSearch.queries.fields.standard_query.after_filter_description',
    id: 'standard_query',
    name: 'standard_query',
    queryKey: 'standard_query',
    validate: [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX],
  },
  boolCloneName: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'categories.labels.name.title',
    id: 'boolCloneName',
    name: 'name',
    hideLabel: true
  },
  boolSearchTags: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'booleanSearch.tags.fields.tags',
    translatePlaceholder: 'booleanSearch.tags.fields.no_tag_options',
    id: 'boolSearchTags',
    name: 'tags',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    closeOnSelect: false,
    allowEmpty: true,
    preselectFirst: false,
    translateTagPlaceholder: 'booleanSearch.tags.fields.add_tag',
    customClass: 'searchTags',
    showNoResults: false,
    translateNoOptions: 'booleanSearch.tags.fields.no_tag_options',
    dropdownDirection: 'bottom'
  },
  boolProjectId: {
    type: FIELD_TYPE.SELECT,
    translatePlaceholder: 'booleanSearch.clone_into_project_placeholder',
    id: 'boolProjectId',
    name: 'projectId',
    searchable: true,
    options: [],
    multiple: false,
    preselectFirst: false,
    optionLabel: "name",
    optionValue: "id",
    hideLabel: true,
    validate: [VALIDATIONS.REQUIRED]
  },
  boolClientId: {
    type: FIELD_TYPE.SELECT,
    translatePlaceholder: 'booleanSearch.clone_into_client_placeholder',
    id: 'boolClientId',
    name: 'clientId',
    searchable: true,
    options: [],
    multiple: false,
    preselectFirst: false,
    optionLabel: "name",
    optionValue: "id",
    hideLabel: true,
    validate: [VALIDATIONS.REQUIRED]
  },
  "should_sync_with_samsara": {
    type: FIELD_TYPE.TOGGLE,
    id: "article-should-sync-with-samsara",
    name: "should_sync_with_samsara",
    translate_label: "articles.labels.should_sync_with_samsara.title",
    labelPosition: 'right',
    style: "flex-basis: 50%"
  },
  // Outlets
  outlet_url: { // conditional validation implemented
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'outlets.form.url',
    id: 'outlet_url',
    name: 'outlet_url',
    style: 'width: 32%',
  },
  outlet_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.name',
    id: 'outlet_name',
    name: 'outlet_name',
    validate: [VALIDATIONS.REQUIRED],
    style: 'width: 32%;',
  },
  original_name: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.original_name',
    id: 'original_name',
    name: 'original_name',
    style: 'width: 32%;',
  },
  languages: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.languages',
    translatePlaceholder: 'outlets.form.languages_placeholder',
    id: 'languages',
    name: 'languages',
    optionLabel: 'name',
    optionValue: 'alpha_2_code',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    closeOnSelect: false,
    clearOnSelect: true,
    preserveSearch: true,
    style: 'width: 32%;',
    validate: [VALIDATIONS.REQUIRED],
  },
  id: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.uid',
    id: 'id',
    name: 'id',
    readOnly: true,
    style: "width: 32%;"
  },
  article_count: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.article_count',
    id: 'article_count',
    name: 'article_count',
    inputType: 'number',
    decimalPoints: 2,
    readOnly: true,
    style: "width: 32%;"
  },
  feeds_info: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.feeds_info',
    id: 'feeds_info',
    name: 'feeds_info',
    readOnly: true,
    style: "width: 32%;"
  },
  mozrank: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.mozrank',
    id: 'mozrank',
    name: 'mozrank',
    readOnly: true,
    style: "width: 32%;"
  },
  description: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'outlets.form.description',
    id: 'description',
    name: 'description',
    style: "width: 32%;"
  },
  publisher_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.publisher_id',
    translatePlaceholder: 'outlets.form.publisher_id_placeholder',
    id: 'publisher_id',
    name: 'publisher_id',
    searchable: true,
    options: [],
    optionLabel: 'name',
    optionValue: 'id',
    hideSelected: true,
    multiple: false,
    allowEmpty: true,
    preselectFirst: false,
    clearOnSelect: true,
    style: "width: 32%;"
  },
  licensing_agency_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.licensing_agency_id',
    translatePlaceholder: 'outlets.form.licensing_agency_id_placeholder',
    id: 'licensing_agency_id',
    name: 'licensing_agency_id',
    searchable: true,
    options: [],
    optionLabel: 'name',
    optionValue: 'id',
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    closeOnSelect: false,
    clearOnSelect: true,
    preserveSearch: true,
    style: "width: 32%;"
  },
  outlet_provider_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.outlet_provider_id',
    translatePlaceholder: 'outlets.form.outlet_provider_id_placeholder',
    id: 'outlet_provider_id',
    name: 'outlet_provider_id',
    searchable: true,
    options: [],
    optionLabel: 'name',
    optionValue: 'id',
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    closeOnSelect: false,
    clearOnSelect: true,
    preserveSearch: true,
    style: "width: 32%;"
  },
  reviewed: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.reviewed',
    id: 'outlet-reviewed',
    name: 'reviewed',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29'
  },
  publish_on_mediadb: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.publish_on_mediadb',
    id: 'outlet-publish-on-mediadb',
    name: 'publish_on_mediadb',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29'
  },
  format_million_disabled: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'powerpointTemplate.form.formatMillionDisabled',
    id: 'format_million_disabled',
    name: 'format_million_disabled',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29'
  },
  macro_for_all_charts: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'powerpointTemplate.form.macro_for_all_charts',
    id: 'macro_for_all_charts',
    name: 'macro_for_all_charts',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29'
  },
  skip_macro: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'powerpointTemplate.form.skipMacro',
    id: 'skip_macro',
    name: 'skip_macro',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29'
  },
  autoremove_manual_content: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.autoremove_manual_content',
    id: 'outlet-is-nla-autoremove',
    name: 'autoremove_manual_content',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29',
    translate_label_tooltip: 'outlets.form.autoremove_manual_content_tooltip'
  },
  smart_summary: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.smart_summary',
    id: 'smart_summary',
    name: 'smart_summary',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox mt29',
    translate_label_tooltip: 'outlets.form.smart_summary_tooltip',
  },
  media_subtype: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.media_subtype',
    translatePlaceholder: 'outlets.form.media_subtype_placeholder',
    id: 'media_subtype',
    name: 'media_subtype',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: false,
    preselectFirst: false,
    clearOnSelect: true,
    validate: [VALIDATIONS.REQUIRED],
    style: "width: 32%;"
  },
  active: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.active',
    id: 'outlet-active',
    name: 'active',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox'
  },
  licensing_required: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.licensing_required',
    id: 'licensing_required',
    name: 'licensing_required',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox'
  },
  enable_auto_release: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.enable_auto_release',
    id: 'enable_auto_release',
    name: 'enable_auto_release',
    style: "width: 32%;",
    inputWrapperClass: 'inline-checkbox'
  },
  frequency: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.frequency',
    translatePlaceholder: 'outlets.form.frequency_placeholder',
    id: 'frequency',
    name: 'frequency',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: false,
    validate: [VALIDATIONS.REQUIRED],
    style: "width: 32%;"
  },
  outlet_sector_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.outlet_sector_id',
    translatePlaceholder: 'outlets.form.outlet_sector_id_placeholder',
    id: 'outlet_sector_id',
    name: 'outlet_sector_id',
    searchable: true,
    options: [],
    optionLabel: 'name',
    optionValue: 'id',
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    closeOnSelect: false,
    clearOnSelect: true,
    preserveSearch: true,
    style: "width: 32%;"
  },
  outlet_category_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.outlet_category_id',
    translatePlaceholder: 'outlets.form.outlet_category_id_placeholder',
    id: 'outlet_category_id',
    name: 'outlet_category_id',
    searchable: true,
    multiple: false,
    groupValues: "options",
    groupLabel: "label",
    isGroupOption: true,
    groupSelect: true,
    clearOnSelect: true,
    optionValue: "id", // track-by
    optionLabel: "name", // label
    options: [],
    style: "width: 32%;"
  },
  priority_level: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.priority_level',
    translatePlaceholder: 'outlets.form.priority_level_placeholder',
    id: 'priority_level',
    name: 'priority_level',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: true,
    preselectFirst: false,
    clearOnSelect: true,
    style: "width: 32%;"
  },
  carma_ocr_provider: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.carma_ocr_provider',
    translatePlaceholder: 'outlets.form.carma_ocr_provider_placeholder',
    id: 'carma_ocr_provider',
    name: 'carma_ocr_provider',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: true,
    preselectFirst: false,
    clearOnSelect: true,
    style: "width: 32%;"
  },
  global_region_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.global_region_id',
    translatePlaceholder: 'outlets.form.global_region_id_placeholder',
    id: 'global_region_id',
    name: 'global_region_id',
    optionLabel: 'name',
    optionValue: 'id',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: true,
    preselectFirst: false,
    clearOnSelect: true,
    style: 'width: 32%;',
  },
  country_code: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.location_id',
    translatePlaceholder: 'outlets.form.location_id_placeholder',
    id: 'country_code',
    name: 'country_code',
    options: [],
    searchable: true,
    hideSelected: false,
    allowEmpty: true,
    optionLabel: 'name',
    optionValue: 'alpha_2_code',
    validate: [VALIDATIONS.REQUIRED],
    style: 'width: 32%;',
  },
  state: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.county_id',
    translatePlaceholder: 'outlets.form.county_id_placeholder',
    id: 'state',
    name: 'state',
    options: [],
    optionLabel: 'state',
    optionValue: 'state',
    searchable: true,
    hideSelected: false,
    allowEmpty: true,
    style: 'width: 32%;',
  },
  address: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.address',
    id: 'address',
    name: 'address',
    style: 'width: 49%;',
  },
  city: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.city',
    id: 'city',
    name: 'city',
    style: 'width: 49%;',
  },
  scope_type: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.scope_type',
    translatePlaceholder: 'outlets.form.scope_type_placeholder',
    id: 'scope_type',
    name: 'scope_type',
    options: [],
    searchable: true,
    hideSelected: true,
    allowEmpty: true,
    style: 'width: 32%;',
  },
  quality_assurance_date: {
    type: FIELD_TYPE.CALENDAR,
    id: "quality_assurance_date",
    name: "quality_assurance_date",
    translate_label: "outlets.form.quality_assurance_date",
    inputClass: 'input-ui',
    editable: true,
    clearable: true,
    valueType: 'date',
    format: 'D MM YYYY',
    style: 'width: 32%;',
  },

  ...aliasInputFields, // there are quite a few of these, let's get them generated

  channel: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.channel',
    id: 'channel',
    name: 'channel',
    style: "width: 32%%;"
  },

  genres: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.genres',
    translatePlaceholder: 'outlets.form.genres_placeholder',
    id: 'genres',
    name: 'genres',
    options: [],
    searchable: true,
    multiple: true,
    hideSelected: true,
    allowEmpty: true,
    style: 'width: 32%;',
  },

  airtime: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.airtime',
    id: 'airtime',
    name: 'airtime',
    style: "width: 32%;"
  },
  paywall_option: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.paywall_label',
    translatePlaceholder: 'outlets.form.paywall_placeholder',
    name: 'paywall_option',
    options: [],
    searchable: true,
    hideSelected: true,
    allowEmpty: true,
    style: 'width: 23.5%;',
  },
  active_subscription: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.active_subscription',
    name: 'active_subscription',
    style: 'width: 23.5%;',
    inputWrapperClass: 'inline-checkbox mt29'
  },
  subscription_expire_date: {
    type: FIELD_TYPE.CALENDAR,
    name: "subscription_expire_date",
    translate_label: "outlets.form.subscription_expire_date",
    inputClass: 'input-ui',
    editable: true,
    clearable: true,
    format: 'D MM YYYY',
    style: 'width: 23.5%;',
  },
  access_office_id: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.access_office_id',
    translatePlaceholder: 'outlets.form.access_office_id_placeholder',
    id: 'access_office_id',
    name: 'access_office_id',
    options: [],
    optionLabel: 'name',
    optionValue: 'id',
    searchable: true,
    multiple: true,
    hideSelected: true,
    allowEmpty: true,
    closeOnSelect: false,
    clearOnSelect: true,
    preserveSearch: true,
    style: 'width: 23.5%;',
  },
  projects: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.projects',
    translatePlaceholder: 'outlets.form.projects_placeholder',
    name: 'projects',
    options: [],
    taggable: true,
    searchable:true,
    placeholder: "Search or add project",
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    clearOnSelect: true,
    style: 'width: 23.5%;'
  },
  paywall_cost_in_usd: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.paywall_cost_in_usd',
    name: 'paywall_cost_in_usd',
    inputType: 'number',
    decimalPoints: 2,
    style: "width: 23.5%;"
  },
  original_paywall_cost: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.original_paywall_cost',
    name: 'original_paywall_cost',
    inputType: 'number',
    decimalPoints: 2,
    style: "width: 23.5%;"
  },
  original_currency: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.original_currency',
    translatePlaceholder: 'outlets.form.original_currency_placeholder',
    name: 'original_currency',
    options: [],
    searchable: true,
    hideSelected: true,
    allowEmpty: true,
    style: 'width: 23.5%;',
  },
  payment_interval: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.payment_interval',
    translatePlaceholder: 'outlets.form.payment_interval_placeholder',
    name: 'payment_interval',
    options: [],
    searchable: false,
    hideSelected: true,
    allowEmpty: true,
    style: 'width: 23.5%;',
  },
  last_cost_checked_date: {
    type: FIELD_TYPE.CALENDAR,
    name: "last_cost_checked_date",
    translate_label: "outlets.form.last_cost_checked_date",
    inputClass: 'input-ui',
    editable: true,
    clearable: true,
    format: 'D MM YYYY',
    style: 'width: 23.5%;',
  },
  login_data: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'outlets.form.login_data',
    name: 'login_data',
    style: "width: 49%;"
  },
  paywall_remarks: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'outlets.form.paywall_remarks',
    name: 'paywall_remarks',
    style: "width: 49%;"
  },
  paywall_e_edition: {
    type: FIELD_TYPE.TOGGLE,
    translate_label: 'outlets.form.paywall_e_edition',
    name: 'paywall_e_edition',
    style: 'width: 23.5%;',
    inputWrapperClass: 'inline-checkbox mt29'
  },
  translation_language:{
    type: FIELD_TYPE.SELECT,
    translate_label: 'outlets.form.translation_language',
    translatePlaceholder: 'outlets.form.languages_placeholder',
    id: 'translation_language',
    name: 'translation_language',
    optionLabel: 'name',
    optionValue: 'alpha_2_code',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: false,
    allowEmpty: true,
    preselectFirst: false,
    closeOnSelect: true,
    clearOnSelect: true,
    preserveSearch: true,
    style: 'width: 32%; margin-right: 2rem',
    validate: [VALIDATIONS.REQUIRED],
  },
  translation_name:{
    type: FIELD_TYPE.INPUT,
    translate_label: 'outlets.form.translation_name',
    id: 'translation_name',
    name: 'translation_name',
    validate: [VALIDATIONS.REQUIRED],
    style: "width: 50%;"
  },
  // Relevancy 
  position: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'relevancy.form.labels.position',
    translatePlaceholder: 'relevancy.form.labels.position',
    name: 'position',
    id: 'position',
    validate: [VALIDATIONS.REQUIRED],
    options: [
      {label: 'Headline', value: 'headline'},
      {label: 'First Paragraph', value: 'first_paragraph'},
      {label: 'Rest of the text', value: 'rest_of_text'},
      {label: 'Headline and content', value: 'headline_and_content'}
    ],
    multiple: false,
    searchable: false,
    hideSelected: true,
    disabled: true,
    style: "width: 25%;"
  },
  inputTags: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'relevancy.form.labels.tags',
    translatePlaceholder: 'relevancy.form.labels.tags',
    name: 'tags',
    id: 'tags',
    options: [],
    multiple: true,
    searchable: true,
    hideSelected: true,
    closeOnSelect: false,
    validate: [VALIDATIONS.REQUIRED],
    style: "width: 50%;",
  },
  inputWeight: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.weight',
    name: 'weight',
    id: 'weight',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    min: 0,
    style: "width: 20%;"
  },

  lowUpperLimit: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.low_upper_limit',
    name: 'low_upper_limit',
    id: 'low_upper_limit',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    style: "width: 10%;"
  },
  mediumLowerLimit: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.medium_lower_limit',
    name: 'medium_upper_limit',
    id: 'medium_lower_limit',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    style: "width: 10%;"
  },
  mediumUpperLimit: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.medium_upper_limit',
    name: 'medium_upper_limit',
    id: 'medium_upper_limit',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    style: "width: 10%;"
  },
  highUpperLimit: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.high_upper_limit',
    name: 'high_upper_limit',
    id: 'high_upper_limit',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    style: "width: 10%;"
  },
  highLowerLimit: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.high_lower_limit',
    name: 'high_upper_limit',
    id: 'high_lower_limit',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    style: "width: 10%;"
  },
  criticalLimit: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'relevancy.form.labels.critical_limit',
    name: 'high_upper_limit',
    id: 'critical_limit',
    inputType: 'number',
    validate: [VALIDATIONS.REQUIRED, VALIDATIONS.NUMBER],
    decimalPoints: 2,
    style: "width: 10%;"
  },
  article_tracker_period: {
    id: 'article_tracker_period',
    format: 'YYYY-MM-DD',
    name: 'article_tracker_period',
    translate_label: 'articleTracker.form.dateFilter',
    range: true,
    type: FIELD_TYPE.CALENDAR,
    clearable: false,
    maxDate: new Date(),
    style:"width:33%; min-width:300px",
    calendarButtonIcon:"fas fa-calendar-alt"
  },
  article_tracker_search: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'articleTracker.form.articlesSearchInput',
    id: 'article_tracker_search',
    name: 'article_tracker_search',
    validate: [VALIDATIONS.REQUIRED],
    style:"width:100%"
  },
  multiSyntax: {
    type: FIELD_TYPE.TOGGLE,
    id: "multiSyntax",
    name: "is_multi",
    translate_label: 'booleanSearch.details.fields.multiSyntax'
  },
  apply_cbs_outlet_timeframes: {
    type: FIELD_TYPE.TOGGLE,
    id: "apply_cbs_outlet_timeframes",
    name: "apply_cbs_outlet_timeframes",
    translate_label: 'booleanSearch.details.fields.apply_cbs_outlet_timeframes',
    labelPosition: 'right',
    style: 'flex-basis: 100%'
  },
  boolean_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.boolean_query',
    id: 'boolean_query',
    name: 'boolean_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  common_boolean_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.common_boolean_query',
    id: 'common_boolean_query',
    name: 'common_boolean_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  weibo_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.provider_query',
    id: 'weibo_query',
    name: 'weibo_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  douyin_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.provider_query',
    id: 'douyin_query',
    name: 'douyin_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  red_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.provider_query',
    id: 'red_query',
    name: 'red_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  wechat_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.provider_query',
    id: 'wechat_query',
    name: 'wechat_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  toutiao_query: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'istarshine.provider_query',
    id: 'toutiao_query',
    name: 'toutiao_query',
    style: 'width: 100%; min-height: 200px;',
    validate: []
  },
  handles: {
    type: FIELD_TYPE.SELECT,
    translate_label: 'istarshine.handles',
    translatePlaceholder: 'istarshine.handles',
    id: 'handles',
    name: 'handles',
    searchable: true,
    options: [],
    hideSelected: true,
    multiple: true,
    allowEmpty: true,
    preselectFirst: false,
    taggable: true,
    translateTagPlaceholder: 'istarshine.handles_add',
    customClass: 'handles',
    showNoResults: false,
    translateNoOptions: 'istarshine.handles_add',
    dropdownDirection: 'bottom',
    validate: []
  },
  // CARMA AI Filtration
  // rest of the fields is used from article filtering rule.
  volume_cap: {
    type: FIELD_TYPE.INPUT,
    translate_label: 'Volume cap',
    id: 'volume_cap',
    name: 'volume_cap',
    inputType: 'number',
    validate: [VALIDATIONS.NUMBER],
    min: 0
  },
  sort_by: {
    type: FIELD_TYPE.SELECT,
    name: 'sort_by',
    id: 'sort_by',
    options: [],
    closeOnSelect: true,
    style: "width: 22%;",
  },
  relevancy_scope: {
    type: FIELD_TYPE.SELECT,
    name: 'relevancy_scope',
    id: 'relevancy_scope',
    options: [],
    closeOnSelect: true,
    style: "width: 22%;",
  },
  relevancy_setting_id: {
    type: FIELD_TYPE.SELECT,
    name: 'relevancy_name',
    id: 'relevancy_name',
    options: [],
    closeOnSelect: true,
    style: "width: 22%;",
  },
  prompt: {
    type: FIELD_TYPE.TEXTAREA,
    translate_label: 'carma_ai.form.labels.prompt',
    name: 'prompt',
    id: 'prompt',
    validate: [VALIDATIONS.REQUIRED],
    style: "width: 100%;"
  },
  ai_scope: {
    type: FIELD_TYPE.SELECT,
    name: 'scope',
    id: 'scope',
    translate_label: 'carma_ai.filtration.scope',
    multiple: false,
    options: [],
    allowEmpty: false
  },
  ai_add_tag: {
    type: FIELD_TYPE.SELECT,
    name: 'action_tags',
    id: 'action_tags',
    translate_label: 'carma_ai.filtration.action_tags',
    multiple: true,
    options: [],
    internalSearch: true,
    searchable: true
  },
  ai_pipeline_enabled: {
    type: FIELD_TYPE.TOGGLE,
    name: 'pipeline_enabled',
    id: 'pipeline_enabled',
    translate_label: 'carma_ai.filtration.pipeline_enabled',
    translate_label_tooltip: 'carma_ai.filtration.pipeline_enabled_tooltip'
  },
  custom_industry: {
    type: FIELD_TYPE.TOGGLE,
    name: 'custom_industry',
    id: 'custom_industry',
    translate_label: 'carma_ai.filtration.custom_industry'
  }
};

const TRACKER_FILTERS = {
  ALL_RESULTS: "all",
  FOUND: "found",
  NOT_FOUND: "not found",
  EXACT_MATCH: "exact match"
}

const MAX_TRACKER_URLS = 200;

const TAG_SEARCH_SCOPE = {
  PARENT: 'parent',
  CHILDREN: 'children',
  BOTH: 'both'
}

const ARTICLES = {
  FILTERS: {
    CREATED_AT: 'created_at',
    PUBLISHED_AT: 'published_at',
  },
  ERRORS: {
    CODE: {
      MISSING_CATEGORIES: 'missing_categories',
      CODED_ARTICLES_SELECTED: 'coded_articles_selected',
    }
  }
}

const CATEGORIES = {
  ERRORS: {
    TAGS_IN_USE: 'category_tags_in_use'
  }
}

const ARTICLES_EXPORT = {
  COLUMNS: [
    'id',
    'headline',
    'coding_id',
    'assigned_to',
    'media_subtype',
    'country',
    'language',
    'comments',
    'created_at',
    'published_at',
    'due_date',
    'status',
    'outlet_id',
    'outlet_name',
    'outlet_tier',
    'insight_url',
    'original_url',
    'authors'
  ],
  SOCIAL_COLUMNS: ['authors_handle', 'gender', 'sentiment', 'followers', 'likes', 'no_comments', 'shares', 'views', 'reactions'],
  NEW_COLUMNS: ['relevancy_level', 'relevancy_score']
}
const FIXED_TABLE_COLUMNS = ["id", "headline"];

const BODHI_CATEGORIES = ['Competitors', 'Custom Industry', 'Organizations', 'People', 'Places', 'Products'];

const EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs='; // A transparent 1x1 pixel GIF

const SOCIAL = {
  MEDIA_PLATFORMS: [
    { label: 'articles.social_posts.providers.fb', value: 'facebook' },
    { label: 'articles.social_posts.providers.ig', value: 'instagram' },
    { label: 'articles.social_posts.providers.social-linkedin', value: 'linkedin' },
    { label: 'articles.social_posts.providers.reddit_mention', value: 'reddit' },
    { label: 'articles.social_posts.providers.tiktok', value: 'tiktok' },
    { label: 'articles.social_posts.providers.gnip', value: 'gnip' },
    { label: 'articles.social_posts.providers.yt', value: 'youtube' }
  ],
  INFLUENCER_MEDIA_TYPES: [
    { label: 'articles.social_posts.providers.yt', value: 'yt_mention' },
    { label: 'articles.social_posts.providers.tiktok', value: 'tiktok_mention' },
    { label: 'articles.social_posts.types.ig', value: 'ig_mention' }
  ],
  ACCOUNT_TYPES: [
    { label: 'articles.social_posts.account_types.verified', value: 'true' },
    { label: 'articles.social_posts.account_types.unverified', value: 'false' }
  ],
  
}

module.exports = {
  SUPPORTED_IMAGE_TYPES: SUPPORTED_IMAGE_TYPES,
  BULK_UPDATE: BULK_UPDATE,
  ARTICLES_EXPORT: ARTICLES_EXPORT,
  FIXED_TABLE_COLUMNS: FIXED_TABLE_COLUMNS,
  RAILS: {
    ENV: "staging",
    PRODUCTION: "some content",
    DEVELOPMENT: "some content"
  },
  CODING_TABS: {
    EDITOR: "editor",
    TOPLINE: "topline",
    SOURCES: "sources",
    OUTLETS: "outlets",
    HISTORY: "history"
  },
  PROJECTS: {
    DEFAULT_CURRENCY: 'USD'
  },
  FIELD_TYPE: FIELD_TYPE,
  VALIDATIONS: VALIDATIONS,
  CUSTOM_VALIDATIONS: CUSTOM_VALIDATIONS,
  INPUT_FIELDS: INPUT_FIELDS,
  TAG_TYPE: {
    ORGANIZATION: "organizations",
    CATEGORY: "categories"
  },
  TAG_SELECTABILITY: {
    ZEROORMORE: "zeroOrMore",
    ONEORMORE: "oneOrMore",
    ONLYONE: "onlyOne"
  },
  STATEMENT_SCORE_LIMIT: -1,
  DEFAULT_TAG_WEIGHT: 1,
  TAG_CATEGORY: {
    ORGANIZATION: "organization",
    ARTICLELEVEL: "articleLevel",
    ARTICLE_LEVEL: "article_feature",
    SOURCES: "sources",
    GROUPING: "grouping",
    MEDIA_TAG: "media_tag"
  },
  MENTIONS_ARTICLE_AREA: {
    ARTICLE_FEATURE: "article_feature"
  },
  FORMATS: {
    SHORT_DATE: "DD/MM"
  },
  USER_PERMISSIONS,
  CATEGORY_TYPES: {
    ARTICLE_FEATURE: 1,
    ARTICLE_DETAIL: 2,
    MEDIA_FEATURE: 3,
    ORGANIZATION: 4,
    GROUPING: 5,
    SOURCE: 6,
    MEDIA_TAG: 7
  },
  SCORING_METHODS: {
    FAVOURABILITY_IQ: 1,
    IMPACT_SCORE: 2,
    FAVOURABILITY: 3,
    NONE: 4,
    CUSTOM: 5
  },
  SCORING_OUTPUT_METRICS: {
    IMPRESSIONS: "impressions",
    GRPS: "grps",
    AVE: "ave"
  },
  CUSTOM_SCORE_METHODS: {
    AVG: "average",
    SUM: "sum"
  },
  SHORTCUT_COMMANDS: {
    NEXT_ORGANIZATION: 'next_organization',
    NEXT_PARAGRAPH: 'next_paragraph',
    PREVIOUS_PARAGRAPH: 'previous_paragraph',
    PARAGRAPH_REDUCE_SENTENCE: 'paragraph_reduce_sentence',
    PARAGRAPH_ADD_SENTENCE: 'paragraph_add_sentence',
    TOP_LINE: 'top_line',
    SOURCES: 'sources',
    OUTLETS: 'outlets',
    EDITOR: 'editor',
    OPTIONS: 'options',
    CATEGORY_TAGS_MENU: 'category_tags_menu',
    ORGANIZATION_TAGS_MENU: 'organization_tags_menu',
    ADD_TAG: 'add_tag',
    CLEAR_CLIPBOARD: 'clear_clipboard',
    PUBLISH_CLIP: 'publish_clip',
    NEXT_CLIP: 'next_clip',
    PREVIOUS_CLIP: 'previous_clip',
    SEARCH: 'search',
    BACK_TO_CATEGORY_TAGS_MENU: 'back_to_category_tags_menu',
    BACK_TO_ARTICLE_LIST: 'back_to_article_list',
    UNDO: 'undo',
    REDUCE_POINTS: 'reduce_points'
  },
  TITLES,
  DAYS_OF_WEEK: [{
    value: 'monday',
    label: 'Monday'
  },{
    value: 'tuesday',
    label: 'Tuesday'
  },{
    value: 'wednesday',
    label: 'Wednesday'
  },{
    value: 'thursday',
    label: 'Thursday'
  },{
    value: 'friday',
    label: 'Friday'
  },{
    value: 'saturday',
    label: 'Saturday'
  },{
    value: 'sunday',
    label: 'Sunday'
  }],
  QUERIES,
  ARTICLE_STATUS,
  ARTICLES,
  MAX_ARTICLES_TO_LIST: 10000,
  MEDIA_TYPES,
  MEDIA_SUBTYPES,
  CATEGORIES,
  GENDER: {
    MALE: 'male',
    FEMALE: 'female',
    UNKNOWN: 'unknown'
  },
  SENTIMENT: {
    NEGATIVE: -2,
    SLIGHTLY_NEGATIVE: -1,
    NEUTRAL: 0,
    SLIGHTLY_POSITIVE: 1,
    POSITIVE: 2
  },
  SOCIALS_EXCLUDED_OUTLETS: ['Youtube'],
  TRACKER_FILTERS,
  MAX_TRACKER_URLS,
  TAG_SEARCH_SCOPE,
  ERROR_CODES: {
    UNIQUE_VIOLATION_CODE: 23505
  },
  BODHI_CATEGORIES,
  EMPTY_IMAGE,
  SOCIAL
};